import React, { useState, useEffect } from 'react';
import { message } from 'antd';
import { useAtom } from 'jotai';
import { userAtom } from '../atom';

function Feedback() {
  const currentUser = useAtom(userAtom)?.[0];
  const [sending, setSending] = useState(false);

  const [formData, setFormData] = useState({
    fName: '',
    lName: '',
    Email: '',
    Feedback: '',
  });

  useEffect(() => {
    document.title = 'Feedback — SitsCom';
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (currentUser?.email) {
      setFormData(prev => ({ ...prev, Email: currentUser.email }));
    }
  }, [currentUser]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    const parsed = {
      Name: `${formData.fName} ${formData.lName}`.trim(),
      Email: formData.Email,
      Feedback: formData.Feedback,
      Type: 'General',
    };

    try {
      const response = await fetch(process.env.REACT_APP_API_LINK, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(parsed),
      });
      if (response.ok) {
        message.success('Thanks for your feedback!');
        setFormData({ fName: '', lName: '', Email: '', Feedback: '' });
      } else {
        message.warning('Failed to send feedback. Please try again.');
      }
    } catch (error) {
      message.error('Error sending feedback');
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <div className="feedback-page page-container">
        <div className="feedback-header fade-in-up" style={{ animationDelay: '0.05s', opacity: 0 }}>
          <h1>Share your feedback</h1>
          <p>
            We value your feedback! Whether you have suggestions, experiences, or ideas to share,
            your insights help us improve and enhance our services for everyone.
          </p>
        </div>

        <div className="feedback-form fade-in-up" style={{ animationDelay: '0.15s', opacity: 0 }}>
          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label>First name</label>
                <input
                  type="text"
                  name="fName"
                  value={formData.fName}
                  onChange={handleChange}
                  placeholder="John"
                  required
                />
              </div>
              <div className="form-group">
                <label>Last name</label>
                <input
                  type="text"
                  name="lName"
                  value={formData.lName}
                  onChange={handleChange}
                  placeholder="Doe"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                type="email"
                name="Email"
                value={formData.Email}
                onChange={handleChange}
                placeholder="you@example.com"
                required
              />
            </div>

            <div className="form-group">
              <label>Feedback</label>
              <textarea
                name="Feedback"
                value={formData.Feedback}
                onChange={handleChange}
                placeholder="Tell us what you think..."
                required
                rows={5}
              />
            </div>

            <div className="form-submit fade-in-up" style={{ animationDelay: '0.25s', opacity: 0 }}>
              <button type="submit" className="btn btn-primary btn-lg" disabled={sending} style={{ width: '100%' }}>
                {sending ? 'Sending...' : 'Submit feedback'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Feedback;
